import { useState } from "react";

import Ingreso from "../formularios/Ingreso";
import classes from "./IngresoModal.module.css";
import cancel from "../../img/icono_cancel.png";

function ModalIngreso(props) {
  const [modal_cierre_visible, setModal_cierre_visible] = useState(
    false
  );

  function closeModal() {
    props.setShowModalIngreso(false);
  }

  function funcionesCierre(event) {
    event.stopPropagation();
    setModal_cierre_visible(true);

  }

  return (
    <div
      className={classes.modalContainer}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div
        className={classes.modal}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div
          className={classes.closeModal}
          onClick={funcionesCierre}
        >
          <img className={classes.closeModal} src={cancel} alt="" />
        </div>
        <div>
          <Ingreso
            closeModal={closeModal}
            caso={props.caso}
            key={props.caso ? props.caso.ruc : "ingresoEnProcesoModal"}
            modal_cierre_visible= {modal_cierre_visible}
            setModal_cierre_visible = {setModal_cierre_visible}
          ></Ingreso>
        </div>
      </div>
    </div>
  );
}

export default ModalIngreso;
